export default __webpack_public_path__ + "static/problem-solving-0d575ee44230e224526b5c2f16a922dd.svg";